import { CoverTemplateOptions, TEMPLATE_CONSTANTS } from '../types';

/**
 * Render cover template for a PDF
 */
export const renderCoverTemplate = (options: CoverTemplateOptions): void => {
  const { pdf, coverTitle, entityName, dateOfIssue } = options;

  const halfHeight = pdf.internal.pageSize.getHeight() / 2;
  const xPosition = TEMPLATE_CONSTANTS.COVER_MARGIN_MM;
  const coverTitleY = halfHeight  - TEMPLATE_CONSTANTS.COVER_MARGIN_MM;    
  const entityNameY = halfHeight;  
  const dateOfIssueY = halfHeight + (TEMPLATE_CONSTANTS.COVER_MARGIN_MM * 2);

  pdf.setFont('helvetica', 'normal');
  pdf.setFontSize(20);
  pdf.text(coverTitle || '', xPosition, coverTitleY);
  
  pdf.setFont('helvetica', 'bold');
  pdf.setFontSize(24);
  pdf.text(entityName || '', xPosition, entityNameY);
  
  pdf.setFont('helvetica', 'normal');
  pdf.setFontSize(16);
  pdf.text(dateOfIssue || '', xPosition, dateOfIssueY);
};
